import { Button, Title } from "../../commonElements";
import moment from "moment";
import { Box, Collapse, IconButton, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { costSummarySelector } from "../../features/costSummary/costSummarySlice";
import { Fragment, useEffect, useMemo, useState } from "react";
// import { InfoIcon } from "../../icons";
import { IoInformationCircleOutline } from "react-icons/io5"
import { signInSelector } from "../../features/signIn/signInSlice";
import { CollapseTitle } from "../../commonElements";
import { stripeSelector } from "../../features/stripe/stripeSlice";

const CostData = ({ data, className }) => (
  <div className={`flex flex-col ${className}`}>
    <p className="capitalize text-base font-normal leading-[1.5]">{data}</p>
  </div>
);

const ReservationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isCollapseTax,setIsCollapseTax] = useState(false)
  const [packageCollpase, setPackageCollapse] = useState(false);
  const costSummaryStates = useSelector(costSummarySelector);
  const signInStates = useSelector(signInSelector);
  const { hotelDetails } = useSelector(stripeSelector);

  // Pull the same data used by Cost Summary from the store
  const { totalCost, costSItems, costSItems2, reservationRespData: reservationRespList } = costSummaryStates;

  // Normalize reservation responses to an array of truthy entries
  const reservationsArray = useMemo(() => {
    const arr = Array.isArray(reservationRespList) ? reservationRespList : (reservationRespList ? [reservationRespList] : []);
    return arr.filter(Boolean);
  }, [reservationRespList]);

  // Safely pick primary data block for header details
  const primaryData = reservationsArray[0]?.data || {};

  const {
    firstName = '',
    lastName = '',
    roomTypeName,
    totalRoom,
    numberOfAdult,
    numberOfChildren,
    numberOfPets,
    reservationData,
    totalAmount,
  } = primaryData;

  let guestDetails = [];
  totalRoom > 0 && guestDetails.push(`${totalRoom} Rooms `);
  numberOfAdult > 0 && guestDetails.push(`${numberOfAdult} Adults `);
  numberOfChildren > 0 && guestDetails.push(`${numberOfChildren} Children `);
  numberOfPets > 0 && guestDetails.push(`${numberOfPets} Pets `);

  // Flatten all reservations from all successful responses
  const allReservations = useMemo(() => {
    let list = [];
    for (const block of reservationsArray) {
      const resv = block?.data?.reservationData?.reservations;
      if (Array.isArray(resv)) list = list.concat(resv);
    }
    return list;
  }, [reservationsArray]);

  const reservationIds = allReservations.map(r => r.reservationId).filter(Boolean);
  const firstReservation = allReservations[0] || {};
  const { arrivalDate, departureDate } = firstReservation;

  useEffect(() => {
    if (!Array.isArray(costSummaryStates?.reservationRespData) || costSummaryStates?.reservationRespData?.length === 0) {
      navigate(`/`)
    }
  }, []);

  // Recompute taxes exactly like Cost Summary
  const { totalTaxCombined, UpdatedTaxAraryCombined } = useMemo(() => {
    let taxes = [];
    if (Array.isArray(costSItems)) {
      for (let i = 0; i < costSItems.length; i++) {
        if (costSItems[i]?.isTaxesAndFees !== true && costSItems[i]?.taxes?.length > 0) {
          taxes = [...taxes, ...costSItems[i].taxes];
        }
      }
    }
    let taxes2 = [];
    if (Array.isArray(costSItems2) && costSItems2.length > 0) {
      for (let block of costSItems2) {
        for (let i = 0; i < block?.costItems.length; i++) {
          if (block?.costItems[i]?.isTaxesAndFees !== true && block?.costItems[i]?.taxes?.length > 0) {
            taxes2 = [...taxes2, ...block?.costItems[i].taxes];
          }
        }
      }
    }
    const allTaxes = [...taxes, ...taxes2];
    let combined = [];
    if (allTaxes.length > 0) {
      combined = allTaxes.reduce((acc, curr) => {
        const index = acc.findIndex((obj) => obj.type === curr.type);
        if (index === -1) {
          acc.push(curr);
        } else {
          const existing = acc[index];
          const sum = Number(existing.taxAmt) + Number(curr.taxAmt);
          acc[index] = { ...existing, taxAmt: sum };
        }
        return acc;
      }, []);
    }
    let totalCombined = 0;
    if (allTaxes.length > 0) {
      for (let i = 0; i < allTaxes.length; i++) {
        totalCombined += Number(allTaxes[i].taxAmt);
      }
    }
    return { totalTaxCombined: totalCombined, UpdatedTaxAraryCombined: combined };
  }, [costSItems, costSItems2]);

  const handleClick = () => {
    window.location.href = hotelDetails?.websiteURL || '/';
  };

  // Hide the QR code when opened from the mobile app (?device=mobile)
  const isMobileDevice = new URLSearchParams(location.search).get("device") === "mobile";

  return (
    <div
      className="w-full h-full  flex flex-col items-center overflow-auto p-4"
    >
      <h1 className="font-normal text-center text-black text-lg md:text-xl mt-[100px]">
        Thank You, {(firstName + " " + lastName).trim()} <br />
        Your reservation is completed.
      </h1>
      <h3 className="font-light text-center text-black mt-[26px] text-[13px] md:text-[16px]">
        Reservation {reservationIds.length > 1 ? 'Numbers' : 'Number'}
      </h3>
      {reservationIds.length > 1 ? (
        <div className="font-normal text-center text-black mt-[10px] mb-[47px] text-xl md:text-[24px]">
          {reservationIds.map((id) => (
            <div key={id}>{id}</div>
          ))}
        </div>
      ) : (
        <h2 className="font-normal text-center text-black mt-[10px] mb-[47px] text-xl md:text-[24px]">
          {reservationIds[0]}
        </h2>
      )}

      {!isMobileDevice && (
        <>
          <h1 className="font-normal text-center text-black text-lg md:text-xl mb-[37px]">
            Customize your stay, access your Mobile Key,
            <br />& more by downloading Shashi App today!
          </h1>

          <div className="mb-[31px]">
            <img
              src={hotelDetails?.webapptheme?.guestAppUrl || "https://res.cloudinary.com/shashigroup/image/upload/v1665658537/static%20Images%20-shashi-hotel-website/shashi-qr-code.png"}
              alt={`${hotelDetails?.hotelName || "Shashi"} app QR code`}
              width="277"
              height="277"
            />
          </div>
        </>
      )}

      <div
        className="w-full p-[15px] md:p-[27px] bg-white"
        style={{ maxWidth: "561px" }}
      >
        <Box
          sx={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Title
            variant={"h2"}
            className={`text-accent-text`}
            sx={{ fontSize: "0.8125rem" }}
            content="reservation details"
          />

          <div className="flex justify-between font-light text-[12px] mt-[38px]">
            <label>Check-In</label>
            <label>Check-Out</label>
          </div>
          <div className="flex justify-between font-normal text-[13px] mt-[6px]">
            <label>{arrivalDate ? moment(arrivalDate).format("ddd, MMM D, YYYY") : '-'}</label>
            <label>{departureDate ? moment(departureDate).format("ddd, MMM D, YYYY") : '-'}</label>
          </div>
        </Box>
        <Box
          sx={{
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "35.3px",
          }}
        >
          {Array.isArray(costSItems2) && costSItems2.length > 0 ? (
            <>
              {costSItems2.map((costSummaryItem, index) => (
                <Fragment key={index}>
                  <div className="flex justify-between items-center my-[15px]">
                    {costSItems2.length > 1 ? (
                      <CollapseTitle
                        openLabel={`${costSummaryItem.room} Cost`}
                        closeLable={`${costSummaryItem.room} Cost`}
                        onClick={() => setPackageCollapse(!packageCollpase)}
                        flag={packageCollpase}
                        className={``}
                      />
                    ) : (
                      <span className="text-base font-normal">
                        {costSummaryItem.room} Cost
                      </span>
                    )}
                    <span className="text-base">
                      {Number((costSummaryItem.costItems.find(ci=>ci.type==="roomCost")?.amt)||0).toLocaleString("en-US",{style:"currency",currency:"USD"})}
                    </span>
                  </div>
                  <Collapse className="pt-1" timeout={2000} in={costSItems2.length > 1 ? packageCollpase : true}>
                    {costSummaryItem.costItems
                      .filter((ci) => ci.type !== "taxesAndFees" && ci.type !== "roomCost")
                      .map((item) => (
                        <Fragment key={`${index}-${item.packageName}-${item.type || ''}`}>
                          <div
                            className={`flex justify-between leading-[39.3px] ${item.type === "taxesAndFees"
                                ? "mb-[12.86px]"
                                : "mb-[15.2px]"
                              }`}
                          >
                            <div className="flex items-center">
                              <CostData
                                data={item.packageName}
                                className={"items-start"}
                              />
                            </div>
                            {item.type === "taxesAndFees" ? (
                              <>
                                <span className={`mt-[4px]`}>
                                  <CostData
                                    data={Number(totalTaxCombined).toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    })}
                                    className={"items-end"}
                                  />
                                </span>
                              </>
                            ) : (
                              <span>
                                  <CostData
                                    data={Number(item?.amt).toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    })}
                                    className={"items-end"}
                                  />
                              </span>
                            )}
                          </div>
                          {item.type === "taxesAndFees" && (
                            <Collapse timeout={700} in={isCollapseTax}>
                              {UpdatedTaxAraryCombined?.length > 0 &&
                                UpdatedTaxAraryCombined.map((subTax, ind) => (
                                  <div className="flex justify-between font-light text-[14px] mb-[3px]" key={ind}>
                                    <p>{subTax.name}</p>
                                    <p>
                                      {Number(subTax?.taxAmt).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                      })}
                                    </p>
                                  </div>
                                ))}
                            </Collapse>
                          )}
                        </Fragment>
                      ))}
                  </Collapse>
                </Fragment>
              ))}

              {Number(totalTaxCombined) > 0 && (
                <>
                  <div
                    className={`flex justify-between leading-[39.3px] ${
                      Number(totalTaxCombined) > 0 && "mb-[12.86px]"
                    }`}
                  >
                    <div className="flex items-center">
                      <CostData
                        onClick={() => setIsCollapseTax(!isCollapseTax)}
                        data={"Estimated Taxes & Fees"}
                        className={"items-start cursor-pointer"}
                      />
                      <IoInformationCircleOutline
                        className="cursor-pointer ml-1"
                        onClick={() => setIsCollapseTax(!isCollapseTax)}
                        style={{ height: "20px", width: "20px", color: "gray" }}
                      />
                    </div>
                    <span className={`mt-[4px]`}>
                      <CostData
                        data={Number(totalTaxCombined).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                        className={"items-end"}
                      />
                    </span>
                  </div>
                  <Collapse timeout={700} in={isCollapseTax}>
                    {UpdatedTaxAraryCombined?.length > 0 &&
                      UpdatedTaxAraryCombined.map((subTax, ind) => (
                        <div className="flex justify-between font-light text-[14px] mb-[3px]" key={ind}>
                          <p>{subTax.name}</p>
                          <p>
                            {Number(subTax?.taxAmt).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })}
                          </p>
                        </div>
                      ))}
                  </Collapse>
                </>
              )}
            </>
          ) : (
            costSItems?.map((costSummaryItem, index) => (
              <Fragment key={index}>
                <div
                  className={`flex justify-between ${
                    costSummaryItem.type === "taxesAndFees"
                      ? Number(totalTaxCombined) > 0 && "mb-[12.86px]"
                      : "mb-[15.2px]"
                  }`}
                >
                  <div className="flex items-center">
                    <CostData
                      data={costSummaryItem.packageName}
                      className={"items-start"}
                    />
                    {costSummaryItem.type === "taxesAndFees" && (
                      <span className="ml-[-2px]">
                        <IoInformationCircleOutline
                          className="ml-1 cursor-pointer"
                          onClick={() => setIsCollapseTax(!isCollapseTax)}
                          style={{ height: "20px", width: "20px", color: "gray" }}
                        />
                      </span>
                    )}
                  </div>
                  {costSummaryItem.type === "taxesAndFees" ? (
                    <span
                      className={`${
                        costSummaryItem.type === "taxesAndFees" && "mt-[4px]"
                      }`}
                    >
                      <CostData
                        data={Number(totalTaxCombined).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                        className={"items-end"}
                      />
                    </span>
                  ) : (
                    <span>
                      <CostData
                        data={Number(
                          costSummaryItem.amount.replace(/[^0-9.-]+/g, "")
                        ).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                        className={"items-end"}
                      />
                    </span>
                  )}
                </div>
                {costSummaryItem.type === "taxesAndFees" && (
                  <Collapse timeout={700} in={isCollapseTax}>
                    {UpdatedTaxAraryCombined?.length > 0 &&
                      UpdatedTaxAraryCombined.map((subTax, ind) => (
                        <div className="flex justify-between font-light text-[14px] mb-[3px]">
                          <p>{subTax.name}</p>
                          <p>
                            {Number(subTax?.taxAmt).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })}
                          </p>
                        </div>
                      ))}
                  </Collapse>
                )}
              </Fragment>
            ))
          )}

          <hr className="border-gray-600 border-solid border-1" />

          <div className="flex justify-between mt-[13.27px] leading-[20.3px]">
            <CostData data={"Total Cost"} className={"items-start"} />
            <CostData
              data={`$${
                typeof totalCost === "string"
                  ? Number(totalCost.replace(/[^0-9.-]+/g, ""))
                      .toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })
                      .slice(1)
                  : ""
              }`}
              className={"items-end"}
            />
          </div>
        </Box>
        {signInStates?.removeLogoutOption ? (
          <a href="inapp://upcoming">
            <Button
              type={"button"}
              className={"mt-[69px] bg-surface text-accent-strong border border-accent-strong"}
              name={"Go to Reservation Details"}
              spanClassName={"font-normal"}
            />
          </a>
        ) : (hotelDetails?.hotelCode === "showcase" || ["staging", "preproduction"].includes(process.env.REACT_APP_SERVER)) ? (
          <Button
            type={"button"}
            onClick={() => { window.location.href = "/"; }}
            className={"mt-[69px] bg-surface text-accent-strong border border-accent-strong"}
            name={"Back to Booking"}
            spanClassName={"font-normal"}
          />
        ) : (
          <Button
            type={"button"}
            onClick={handleClick}
            className={"mt-[69px] bg-surface text-accent-strong border border-accent-strong"}
            name={`Back to ${hotelDetails?.hotelName || 'Hotel'}`}
            spanClassName={"font-normal"}
          />
        )}
      </div>
    </div>
  );
};

export default ReservationSuccess;
